import { render } from "./double_image_info_modal.vue?vue&type=template&id=32d577dc"
import script from "./double_image_info_modal.vue?vue&type=script&lang=ts"
export * from "./double_image_info_modal.vue?vue&type=script&lang=ts"
script.render = render

export default script